let PHONE = Symbol('phone');
let EMAIL = Symbol('email');
let PASSWORD = Symbol('password');
let HAS_NUMBER = Symbol('hasNumber');

const isEmpty = data => {
  if (typeof data === 'string') {
    if (data.trim().length === 0) return true;
    return false;
  }

  if (typeof data === 'number') return false;

  if (data === undefined || data === null) return true;

  if (data.length === 0) return true;

  if (Object.keys(data).length === 0) return true;

  return false;
};

const isString = data => {
  return typeof data === 'string';
};

const isPassword = data => {
  return Regex(PASSWORD, data);
};

const isEmail = data => {
  return Regex(EMAIL, data);
};

const isPhone = data => {
  return Regex(PHONE, data);
};

const hasNumber = data => {
  return Regex(HAS_NUMBER, data);
};

const isValidName = data => {
  if (isString(data) && !isEmpty(data)) {
    return !hasNumber(data);
  }
  return false;
};

const Regex = (type, data) => {
  if (!isString(data)) return false;

  let regex;

  switch (type) {
    case PHONE:
      regex = new RegExp(
        '^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$'
      );
      break;
    case EMAIL:
      regex = new RegExp(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$"
      );
      break;
    case PASSWORD:
      regex = new RegExp(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
      );
      break;
    case HAS_NUMBER:
      regex = /\d/;
      break;
    default:
      return false;
  }

  return regex.test(data);
};

const Validator = {
  isEmpty,
  isString,
  isPassword,
  isEmail,
  isPhone,
  isValidName
};

export default Validator;
